angular.module('nv.shared.background-job-ui.background-job-progress', []);
